export interface Refreshpagestatus {
    creationDate: string;
    id_token: string;
    statustype: string;
    checkupcreated: string;
    checkupcompleted: string;
    raterschange: string;
}